import React, {Suspense, useCallback, useState} from 'react';
import {useHistory} from 'react-router-dom';
import last from 'lodash/last';
import {BackLink} from '../../components/back_link';
import {SearchDocs} from '../../components';

import {ROUTE_INFORMATION} from '../../constants';

const QrReader = React.lazy(() => import('react-qr-reader'));

export const QrCodeScanner = () => {
    const history = useHistory();
    const goToInformation = useCallback(() => history.push(ROUTE_INFORMATION), [history]);

    const [blockchainUid, setBlockchainUid] = useState(null);

    const handleScan = useCallback(
        data => {
            if (data) {
                const uid = last(data.split('/'));
                setBlockchainUid(uid);
            }
        },
        [setBlockchainUid]
    );

    return (
        <div className="flex-col justify-between items-center mb-10">
            <BackLink handleClick={goToInformation}/>
            {blockchainUid ? (
                <SearchDocs defaultValue={blockchainUid}/>
            ) : (
                <Suspense fallback="Загрузка...">
                    <QrReader onScan={handleScan}/>
                </Suspense>
            )}
        </div>
    );
};
